import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{
  title = 'my-store';

  ngOnInit(): void {
    window.open("https://pomelobebes.vercel.app/","_self")
  }
}
